module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//avatar-border.png?v=58226b26";